﻿import checkoutService from '../api/checkout';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'alert-modal',
    template: '#alert-modal-template',
    data: () => ({
        loading: false
    }),
    computed:
    Object.assign(
        mapState({
            modal: state => state.checkout.alertModal
        }),
        mapGetters({
            
        }),
        {
            show() {
                return this.modal.show;
            }
        }
            
        ),
    methods: {
        close: function (key) {
            if (this.modal.options[key].action) {
                this.loading = true;
				if (this.modal.options[key].action == 'redirect') {
					window.location.href = this.modal.options[key].url;
				}
				else if (this.modal.options[key].action == 'goback') {
					window.history.back();
				}
				else if (this.modal.options[key].action == 'reload') {
					window.location.reload(true);
				}
				else if (this.modal.options[key].action == 'noop') {
					var self = this;
					self.loading = false;
					var modalOptions = [{ text: 'OK', action: 'reload' }]
					self.$store.dispatch('updateAlert', { header: this.modal.options[key].header || '', body: this.modal.options[key].body || '', options: modalOptions });
				}
				else if (this.modal.options[key].action == 'post') {
                    var self = this;
                    var parameters = { blockId: this.modal.blockId};
                    checkoutService.asyncPost(this.modal.options[key].url,
                    parameters,
                    (res) => {
                        self.loading = false;
                        var modalOptions = [{ text: 'OK', action: 'reload' }]
                        self.$store.dispatch('updateAlert', { header: this.modal.options[key].header || '', body: res.message, options: modalOptions });
                    },
                    () => {
                        
                    }
                );
                }
                
            } else {
                this.$store.dispatch('hideAlert');
            }
        }
    },
    ready: function () {
        document.addEventListener("keydown", (e) => {
            if (this.show && e.keyCode == 27) {
                this.close();
        }
    });
    }
}